import { create } from 'zustand'
import { createJSONStorage, persist } from 'zustand/middleware'

import { AUTH_STORAGE_KEY } from 'src/app/auth/constants/storage'
import {
  AuthStore,
  AuthStoreState,
  CurrentUser,
  RestoreStatus,
} from 'src/app/auth/store/auth-store/types'

const INITIAL_STATE: AuthStoreState = {
  currentUser: undefined,
  pendingToken: undefined,
  sessionExpired: undefined,
  restoreStatus: 'idle',
}

export const useAuthStore = create<AuthStore>()(
  persist(
    (set, get) => ({
      ...INITIAL_STATE,
      isAuthenticated: () => {
        return !!get().currentUser
      },
      setCurrentUser: (user: CurrentUser | null) => {
        set({
          currentUser: user ?? undefined,
          pendingToken: undefined,
          ...(user
            ? { sessionExpired: undefined }
            : { restoreStatus: 'done' as const }),
        })
      },
      setPendingToken: (token: string | null) => {
        set({ pendingToken: token ?? undefined })
      },
      setSessionExpired: (expired: boolean) => {
        set({ sessionExpired: expired || undefined })
      },
      setRestoreStatus: (status: RestoreStatus) => {
        set({ restoreStatus: status })
      },
    }),
    {
      name: AUTH_STORAGE_KEY,
      storage: createJSONStorage(() => sessionStorage),
      partialize: (state): Pick<AuthStoreState, 'currentUser'> => ({
        currentUser: state.currentUser,
      }),
    },
  ),
)
